import { cn } from '@/lib/utils';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: keyof typeof maxWidthClasses; // Restrict maxWidth to predefined options
}

const maxWidthClasses = {
  sm: 'max-w-screen-sm',
  md: 'max-w-screen-md',
  lg: 'max-w-screen-lg',
  xl: 'max-w-screen-xl',
  '2xl': 'max-w-screen-2xl',
  full: 'max-w-full',
} as const;

/**
 * Container component to constrain content width and center it horizontally.
 * 
 * @param children - The content to be wrapped by the container.
 * @param className - Additional custom classes to style the container.
 * @param maxWidth - Determines the maximum width of the container.
 */
export function Container({
  children,
  className,
  maxWidth = 'xl',
}: ContainerProps): JSX.Element {
  return (
    <div
      className={cn(
        'w-full mx-auto', // Full width and horizontally centered
        maxWidthClasses[maxWidth], // Dynamically apply max width
        className // Allow custom styles to override or extend
      )}
    >
      {children}
    </div>
  );
}
